"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSrcSet = exports["default"] = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var re = /([?&](?:wid|hei)=)\d+/i;
var generateSrcSet = function generateSrcSet(dprs, wid, maxWidth) {
  return function (src) {
    var result = [];
    for (var i = 0; i < dprs.length; i += 1) {
      var _dpr = dprs[i];
      var w = wid * _dpr;
      // eslint-disable-next-line no-bitwise
      var p = ~~w;
      if (w < maxWidth) {
        result[i] = "".concat(src.replace(re, "$1".concat(w === p ? w : p + 1)), " ").concat(_dpr, "x");
      } else {
        result[i] = src.replace(re, "$1".concat(maxWidth));
        break;
      }
    }
    return result;
  };
};
exports.generateSrcSet = generateSrcSet;
var dpr = function dpr(h) {
  if (h > 0) {
    return [h];
  }
  if ((0, _isArray["default"])(h) && h.length > 0) {
    return h;
  }
  return window.devicePixelRatio ? [+window.devicePixelRatio.toFixed(2)] : [1, 1.5, 2];
};
var createResponsiveImageHelper = function createResponsiveImageHelper() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$devicePixelRatio = _ref.devicePixelRatio,
    devicePixelRatio = _ref$devicePixelRatio === void 0 ? undefined : _ref$devicePixelRatio,
    _ref$widths = _ref.widths,
    widths = _ref$widths === void 0 ? undefined : _ref$widths,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 1000 : _ref$maxWidth;
  var dprs = dpr(devicePixelRatio);
  var widthsVal = widths || {
    thumbnail: 100,
    mobile: 250,
    desktop: 650
  };
  return (0, _mapValues["default"])(widthsVal, function (wid) {
    var srcSet = generateSrcSet(dprs, wid, maxWidth);
    return function (src) {
      return {
        srcSet: srcSet(src).join()
      };
    };
  });
};
var _default = createResponsiveImageHelper;
exports["default"] = _default;
//# sourceMappingURL=scene7.js.map